import { createAction } from "@reduxjs/toolkit";
export const FETCH_PORTAL_CONFIG = 'FETCH_PORTAL_CONFIG';
export const fetchPortalConfigAction = createAction(FETCH_PORTAL_CONFIG);